import { graphql } from '@e-socna/data-layer';
import { EMPTY_ARRAY } from '@e-socna/empty';

import { useGraphQLQuery } from '../../hooks/useGraphQLQuery.hook';
import { Loading } from '../../components/Loading';
import { FolderBusinessEntityList } from '../../components/FolderBusinessEntityList';
import { FolderBusinessEntityListVariant } from '../../components/FolderBusinessEntityList/enums/variant.enum';

export const FoldersPage_FoldersWithoutOpenState_QueryDocument = graphql(`
  query FoldersPage_FoldersWithoutOpenState_Query {
    findFoldersWithoutOpenState {
      ...FolderBusinessEntityListCmp_FolderBusinessEntity_Fragment
    }
  }
`);

export const NotOpenFolders = () => {
  const { data, isLoading } = useGraphQLQuery(
    FoldersPage_FoldersWithoutOpenState_QueryDocument,
  );

  if (isLoading) {
    return <Loading />;
  }

  const folders = data?.findFoldersWithoutOpenState ?? EMPTY_ARRAY;

  return (
    <FolderBusinessEntityList
      folderBusinessEntities={folders}
      variant={FolderBusinessEntityListVariant.Grid}
    />
  );
};
